<template>
  <div :class="b()" :style="styleSizeName">
    <div :class="b('switch')" :style="switchStyle">
      <div 
        v-if="option.btnAlign=== 'left' || option.btnAlign=== 'between'" 
        :class="b('switch--pre')" 
        :style="btnStyle"
         @click="handlePre">
        <span :style="btnIconStyle"></span>
      </div>
      <div 
        v-if="option.btnAlign=== 'left'"
        :class="b('switch--next')"
        :style="btnStyle"
         @click="handleNext">
        <span :style="btnIconStyle"></span>
      </div>
      <div :class="b('switch--content')" ref="switchContent">
        <ul ref="switchli">
          <li 
            v-for="item in dataChart" 
            :key="item.id" 
            :style="[liStyle, active===item.id ? activeStyle : unActiveStyle]"
            @click="handleSelect(item)"
          >{{item.name}}</li>
        </ul>
      </div>
      <div 
        v-if="option.btnAlign=== 'right'" 
        :class="b('switch--pre')" 
        :style="btnStyle"
         @click="handlePre">
        <span :style="btnIconStyle"></span>
      </div>
      <div 
        v-if="option.btnAlign=== 'right' || option.btnAlign=== 'between'" 
        :class="b('switch--next')"
        :style="btnStyle"
         @click="handleNext">
        <span :style="btnIconStyle"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "timeline",
  data() {
    return {
      active: 0,
      index: 0
    };
  },
  props: {
    option: Object,
    component: Object,
  },
  watch: {
    dataChart: {
      handler(val) {
        if (val.length !== 0) {
          this.handleSelect(val[0])
          this.index = 0
        }
      },
      immediate: true
    }
  },
  computed: {
    switchStyle() {
      return {
        background: this.option.bgColor,
        borderRadius: this.setPx(this.option.bgBorderRadius),
        padding: this.setPx(this.option.contentSplit)
      }
    },
    btnStyle() {
      return {
        width: this.setPx(this.option.btnSize),
        height: this.setPx(this.option.btnSize),
        background: this.option.btnBgColor,
        borderRadius: this.setPx(this.option.btnBorderRadius)
      }
    },
    btnIconStyle() {
      return {
        borderWidth: this.setPx(this.option.btnIconSize),
        borderRightColor: this.option.btnColor
      }
    },
    liStyle() {
      return {
        padding: `0 ${this.setPx(this.option.labelWidth)}`,
        margin: `0 ${this.setPx(this.option.labelSplit)}`,
        height: this.setPx(this.option.labelHeight),
        lineHeight: this.setPx(this.option.labelHeight),
        borderRadius: this.setPx(this.option.labelBorderRadius),
        fontSize: this.setPx(this.option.labelFontSize)
      }
    },
    activeStyle() {
      return {
        background: this.option.empBgColor,
        color: this.option.empColor
      }
    },
    unActiveStyle() {
      return {
        background: this.option.labelBgColor,
        color: this.option.labelColor
      }
    },
    switchWidth() {
      return this.$refs.switchContent.offsetWidth
    },
    switchNum() {
      return this.$refs.switchli.offsetWidth / this.$refs.switchContent.offsetWidth
    }
  },
  methods: {
    handleSelect(item) {
      this.active = item.id
      this.click('handleChecked', {
        child: this.child,
        value: item.data
      })
    },
    handlePre() {
      this.index--
      this.index < 0 && (this.index = Math.floor(this.switchNum))
      this.$refs.switchli.style.left = this.setPx(this.switchWidth * this.index * -1)
    },
    handleNext() {
      this.index++
      this.index > this.switchNum && (this.index = 0)
      this.$refs.switchli.style.left = this.setPx(this.switchWidth * this.index * -1)
    }
  }
}
</script>

<style lang="scss" scoped>
.avue-echart-timeline {
  &__switch {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    &--pre, &--next {
      cursor: pointer;
      position: relative;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-75%, -50%);
        width: 0;
        height: 0;
        display: inline-block;
        border-style: solid;
        border-color: transparent;
      }
    }
    &--next{
      span {
        transform: translate(-25%, -50%) rotate(180deg);
      }
    }
    &--content {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      position: relative;
      ul {
        display: flex;
        position: absolute;
        left: 0;
        overflow-x: auto;
        overflow-y: hidden;
        list-style: none;
        transition: all 1s;
        li {
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>